import React,{Component} from 'react';
import './SigninAdmin.css';
import Navbar from '../../Components/Navbar/Navbar'
import axios from 'axios'
import {LinkAPI} from '../../../API/API'
import HandleRes from '../../Components/HandleRes/HandleRes';

class SigninAdmin extends Component{
    constructor (props) {
        super(props);
        this.state = {
          email: "admin@admin.com",
          password: "123456789",
          emailError: "",
          passwordError: "",
          networkError: false,
          errordatamessage: false,
          errordatamessagetext: '',
          hasError: false,
        }
      }
      handleChange = event => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
          [event.target.name]: isCheckbox
            ? event.target.checked
            : event.target.value
        });
      }; 
    
      validate = () => {
        let emailError = "";
        let passwordError = "";
        // let passwordError = "";
    
        if (  this.state.password.length < 8) {
          passwordError = "write your password correct";
        }
    
        if (!this.state.email.includes("@"))  {
            emailError = "invalid email";
        }
    
        if (emailError || passwordError) {
          this.setState( { emailError:emailError ,passwordError:passwordError } );
          return false;
        }
    
        return true;
      };
    
      handleSubmit = event => {
        event.preventDefault();
        const {email,password}= this.state
        const isValid = this.validate();
        if (isValid) {
          axios.post(`${LinkAPI}/api/admin/signin`,{email:email ,password:password}
          ).then(res =>{
            localStorage.setItem("AdminTokenKayn",res.data.token)
            window.location.replace("/Admin/orders");
            localStorage.setItem("KaynAdminName", res.data.admin.name)

            }).catch(error=>{
            if (!error.response) {
              this.setState({
                networkError: true
              })
            }  else if (error.response.data.message) {
              this.setState({
                emailError: "",
                passwordError: "",
                errordatamessage: true,
                errordatamessagetext: error.response.data.message
              })
            } else {
              this.setState({
                hasError: true,
              })
            }
            })
        }
      };
    render(){
      document.title ="Kayn"; 
      document.getElementsByTagName("META")[1].content="Kayn Sign in admin";
      document.documentElement.lang = 'en';
        return(
            <div className="AppEN signin">
            <Navbar/>
            <div className='container'>
                <div className="AdminSign row my-0">
                    <div className="contantcover col-6  text-white p-5">
                            <p className="fontsize10 ml-5 mb-3 font-weight-bold ">Loco Pack</p>
                            <p className="fontsize11 ml-5 mb-1 font-weight-bold ">Admin access</p>

                    </div>
                    <div className=" col-6  ">
                            
                    </div>
                    <div className="col-md-6 form float-md-right  ">
                       <div className="contantform text-center p-4 ">
                            <h3 className="fontsize1 my-4">Sign In </h3>
                            <p className="fontsize6 mt-4 mb-1 ">Sign in to continue access pages</p>
                            <p className="fontsize6  m-0">E-mail:admin@admin.com</p>
                            <p className="fontsize6 m-0">password:123456789</p>
                                <form className="px-lg-5" onSubmit={this.handleSubmit}>
                                    <div className="form-group mb-4 mt-2">
                                        <input type="email" className={"form-control badge-pill p-3 " + (this.state.emailError ? 'is-invalid' : '')} placeholder="Email Address" name="email" value={this.state.email} onChange={this.handleChange}required />
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.emailError}
                                        </div>
                                    </div><div className="form-group my-4">
                                        <input type="password" className={"form-control badge-pill p-3 " + (this.state.passwordError ? 'is-invalid' : '')} placeholder=" password" name="password" value={this.state.password}  onChange={this.handleChange}required />
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.passwordError}
                                        </div>
                                    </div>
                                    {(this.state.errordatamessage ?
                      <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                        {this.state.errordatamessagetext}
                      </div> : '')}
                                    <button type="submit" className="btn btn-primary badge-pill btn-block shadow p-2 mb-2"  >LOGIN</button>
                                </form>

                       
                       </div>
                    </div>
                </div>
                </div>
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
        {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default SigninAdmin;